// Vendor libraries
import { EventEmitter } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "../../../../../../../ycharts/static/ts/features/directives/disabled/disabled.directive";
import * as i3 from "../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i4 from "../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/modal-base.component";
import * as i5 from "../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-header.component";
function StressTestTemplateSelectorModalComponent_div_7_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16)(1, "div", 17);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(2, "svg", 18);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", "icon-check");
} }
function StressTestTemplateSelectorModalComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵlistener("click", function StressTestTemplateSelectorModalComponent_div_7_Template_div_click_0_listener() { const i_r2 = i0.ɵɵrestoreView(_r1).index; const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.selectStressTest(i_r2)); });
    i0.ɵɵelementStart(1, "div", 13)(2, "span", 14)(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(5, StressTestTemplateSelectorModalComponent_div_7_div_5_Template, 3, 1, "div", 15);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const stressTest_r4 = ctx.$implicit;
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate2("", stressTest_r4.name, " ", stressTest_r4.description);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", stressTest_r4.selected);
} }
export class StressTestTemplateSelectorModalComponent {
    constructor() {
        this.submitModalHandler = new EventEmitter();
        this.selectedStressTestTemplates = [];
        this.open = false;
    }
    selectStressTest(index) {
        this.stressTestTemplates[index].selected = !this.stressTestTemplates[index].selected;
        if (this.stressTestTemplates[index].selected) {
            this.selectedStressTestTemplates.push(this.stressTestTemplates[index]);
        }
        else {
            this.selectedStressTestTemplates = this.selectedStressTestTemplates.filter((_) => _.name !== this.stressTestTemplates[index].name);
        }
    }
    resetModal() {
        this.stressTestTemplates = this.stressTestTemplates.map((_) => {
            return { ..._, selected: false };
        });
        this.selectedStressTestTemplates = [];
    }
    submitModal() {
        this.submitModalHandler.emit(this.selectedStressTestTemplates);
        this.closeModal();
    }
    openModal() {
        this.resetModal();
        this.open = true;
    }
    closeModal() {
        this.open = false;
    }
}
StressTestTemplateSelectorModalComponent.ɵfac = function StressTestTemplateSelectorModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || StressTestTemplateSelectorModalComponent)(); };
StressTestTemplateSelectorModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: StressTestTemplateSelectorModalComponent, selectors: [["ycn-stress-test-template-selector-modal"]], inputs: { stressTestTemplates: "stressTestTemplates" }, outputs: { submitModalHandler: "submitModalHandler" }, standalone: false, decls: 12, vars: 6, consts: [[3, "closeModalHandler", "open"], ["resetModalText", "Reset", 3, "closeModalHandler", "resetModalHandler", "header"], [1, "modal-body"], [1, "modal-section"], ["id", "metric-by-category-list-container", 1, "linked-lists"], [1, "linked-list", "user-select-none"], [1, "linked-list-body"], ["class", "linked-list-item-body linked-list-sublist", 3, "click", 4, "ngFor", "ngForOf"], [1, "modal-footer", "user-select-none"], [1, "modal-footer-actions"], [1, "btn", "btn-text", 3, "click", "textContent"], ["ycnDisabled", "", 1, "btn", "btn-primary", 3, "click", "disabled", "textContent"], [1, "linked-list-item-body", "linked-list-sublist", 3, "click"], [1, "linked-list-item-header"], [1, "text-gray-10"], ["class", "linked-list-item-controls", 4, "ngIf"], [1, "linked-list-item-controls"], [1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-check"], ["role", "img", "ycnIcon", "", 3, "name"]], template: function StressTestTemplateSelectorModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ycn-modal-base", 0);
        i0.ɵɵlistener("closeModalHandler", function StressTestTemplateSelectorModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { return ctx.closeModal(); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 1);
        i0.ɵɵlistener("closeModalHandler", function StressTestTemplateSelectorModalComponent_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { return ctx.closeModal(); })("resetModalHandler", function StressTestTemplateSelectorModalComponent_Template_ycn_simple_modal_header_resetModalHandler_1_listener() { return ctx.resetModal(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 2)(3, "div", 3)(4, "div", 4)(5, "div", 5)(6, "div", 6);
        i0.ɵɵtemplate(7, StressTestTemplateSelectorModalComponent_div_7_Template, 6, 3, "div", 7);
        i0.ɵɵelementEnd()()()()();
        i0.ɵɵelementStart(8, "div", 8)(9, "div", 9)(10, "div", 10);
        i0.ɵɵlistener("click", function StressTestTemplateSelectorModalComponent_Template_div_click_10_listener() { return ctx.closeModal(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "div", 11);
        i0.ɵɵlistener("click", function StressTestTemplateSelectorModalComponent_Template_div_click_11_listener() { return ctx.submitModal(); });
        i0.ɵɵelementEnd()()()();
    } if (rf & 2) {
        i0.ɵɵproperty("open", ctx.open);
        i0.ɵɵadvance();
        i0.ɵɵproperty("header", "Select Stress Test Template");
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("ngForOf", ctx.stressTestTemplates);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("textContent", "Cancel");
        i0.ɵɵadvance();
        i0.ɵɵproperty("disabled", !ctx.selectedStressTestTemplates.length)("textContent", "Submit");
    } }, dependencies: [i1.NgForOf, i1.NgIf, i2.DisabledDirective, i3.IconDirective, i4.ModalBaseComponent, i5.SimpleModalHeaderComponent], encapsulation: 2 });
